import classNames from 'classnames';
import React from 'react';

import css from './IconCheese.module.css';

const IconCheese = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
    >
      <path
        d="M33.26 17.075h15.357V53.27l-15.519-.124V52.12zM48.617 17.075H33.272l4.755-7.549h15.345zM53.372 9.526H38.047V6.047c0-.578.47-1.047 1.05-1.047h13.225c.58 0 1.05.469 1.05 1.047v3.479z"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="m53.372 9.526-4.755 7.549L57 16.43z"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M48.617 17.075V53.27L57 51.022V16.43z"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="m33.912 58.437 4.135.563V36.557l-15.527-9.2c-11.53.563-13.492 3.596-14.168 5.157 0 0-3.041 13.128 0 22.443l16.31 2.217h.012-.012a5.133 5.133 0 0 1-.057-.735c0-2.688 2.188-4.859 4.872-4.859a4.86 4.86 0 0 1 4.873 4.859c0 .712-.15 1.39-.438 1.998z"
        fill="#ffffff"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M24.605 35.914c0 1.883-1.532 3.4-3.41 3.4a3.397 3.397 0 0 1-3.41-3.4c0-.758.242-1.459.68-2.022l5.91.804c.15.38.23.781.23 1.218zM8.352 32.514l29.695 4.043-29.695-4.043z"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <ellipse
        cx="15.438"
        cy="47.64"
        rx="3.952"
        ry="3.941"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <ellipse
        cx="31.08"
        cy="43.179"
        rx="2.704"
        ry="2.696"
        fill="none"
        stroke="#011602"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default IconCheese;
